module.exports = __webpack_public_path__ + "media/images/fallback/photo/thumb_250_default-e051cab815ad82d91f38cd06b415e351.png";